import { VStack, Stack, Box, Center, Spacer } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isOfferFailed } from '../../../../../../../../types/Quotes';
import InsuranceCompanyLogo from '../../../../../../../common/src/components/InsuranceCompanyLogo';
import MatchingScore from '../../../../../../../common/src/components/MatchingScore';
import LabelValueWithSkeleton from '../../../../../components/offers/LabelValueWithSkeleton';
import useOffer from '../../../store/offer/useOffer';
import OfferPaymentIntervalSelect from './OfferPaymentIntervalSelect';
import OfferPremium from './OfferPremium';
import SingleOfferErrorMessage from './SingleOfferErrorMessage';

export const OFFER_RIGHT_SIDE_WIDTH = '2xs';

const OfferResult: React.FC = () => {
  const { t } = useTranslation();
  const { offer, isLoading } = useOffer();

  const paymentIntervalSpec = offer.details?.calculation_specs?.find(
    ({ calc_type }) => calc_type === 'PAYMENT_INTERVAL',
  );

  return (
    <VStack
      w={{ base: '100%', tablet: OFFER_RIGHT_SIDE_WIDTH }}
      align="stretch"
      borderLeft="1px"
      borderColor="gray.50"
      flexShrink={0}
    >
      <Stack
        flexDirection={{
          base: 'row',
          tablet: 'column',
        }}
        p="6"
        flexGrow={1}
        wrap="wrap"
        align="stretch"
        justify="space-between"
        spacing="3"
      >
        <Box
          maxW="24"
          maxH="20"
          display={{
            base: 'block',
            tablet: 'none',
          }}
          mr="6"
        >
          <InsuranceCompanyLogo insuranceCompany={offer.info.company.key} />
        </Box>
        {isOfferFailed(offer) ? (
          <Center h="100%" maxW="56">
            <SingleOfferErrorMessage offer={offer} />
          </Center>
        ) : (
          <>
            <OfferPremium
              paymentInterval={offer.details?.payment_interval}
              price={offer.premium?.total_premium}
              currency={offer.premium?.currency}
              isLoading={isLoading}
              policyCosts={offer.premium?.recurring_policy_costs}
              companyKey={offer.info?.company?.key}
            />
            <Spacer display={{ base: 'none', tablet: 'block' }} />
            {offer.matching_score && (
              <LabelValueWithSkeleton
                label={t('OFFERS_OVERVIEW_SINGLE-OFFER_QUALITY_LABEL')}
              >
                <MatchingScore
                  score={offer.matching_score}
                  tooltip={t(
                    'OFFERS_OVERVIEW_SINGLE-OFFER_QUALITY_DESCRIPTION',
                  )}
                />
              </LabelValueWithSkeleton>
            )}
            {paymentIntervalSpec && (
              <OfferPaymentIntervalSelect
                calcSpec={paymentIntervalSpec}
                paymentInterval={offer.details?.payment_interval}
              />
            )}
          </>
        )}
      </Stack>
    </VStack>
  );
};

export default OfferResult;
